import React, { useState, useEffect, useContext } from "react";
import { Link } from "gatsby";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

// Components //
import FilterTagEncTal from "../../atoms/filter-tag-encontrar-talento/filterTagEncTal";

// Context //
import TalentsContext from "../../../contexts/talentsContext";

// Helpers //
import { removeCheckedRadio, removeChecked } from "../../../utils/helpers";

// Styles //
import "./filterTagListEncTal.scss";

const FilterTagListEncTal = ({ handleFilters }) => {
    const {
        selectedFilters,
        initialSelectedFilters,
        setSelectedFilters,
    } = useContext(TalentsContext);
    
    const [tags, setTags] = useState<any>([]);
    const [indexSection, setIndexSection] = useState<number>(0);
    const keys = Object.keys(selectedFilters);
    const [tagsAll, setTagsAll] = useState<any>([]);
    const { document } = useBrowserMode();

    const disableFilters = () => {
        const checkboxes = document.querySelectorAll("input[type=checkbox]");
        const radios = document.querySelectorAll("input[type=radio]");
        const radiosLink = document.querySelectorAll("a.wrapper-filter");

        if (tagsAll.length > 23) {
            checkboxes.forEach((checkbox) => {
                if (!checkbox.checked) {
                    checkbox.classList.add("disabled");
                }
            });
            radios.forEach((radio) => {
                if (!radio.checked) {
                    radio.classList.add("disabled");
                }
            });
            radiosLink.forEach((link) => {
                link.classList.add("disabled");
            })
        } else {
            checkboxes.forEach((checkbox) => {
                checkbox.classList.remove("disabled");
            });
            radios.forEach((radio) => {
                radio.classList.remove("disabled");
            });
            radiosLink.forEach((link) => {
                link.classList.remove("disabled");
            })
        }
    };

    const createTagsList = () => {
        let tags: string[] = [];
        keys.forEach((key) => {
            if (selectedFilters[key].items.length > 0) {
                selectedFilters[key].items.forEach((item) => {
                    tags.push(item);
                });
            }
        });

        setTags(tags);
        setTagsAll(tags);

        if (indexSection === 0) {
            setTags(tags.slice(0, 8));
        } else if (indexSection === 1) {
            setTags(tags.slice(8, 16));
        } else {
            setTags(tags.slice(16));
        }
    };

    (function setChecked()  {
        selectedFilters.area.items.forEach(item => {
            const checkbox = document?.getElementById(`${item.name}-${item.value}`) as HTMLInputElement;
            if(checkbox) {
                checkbox.checked = true;
            }
        })
    })();

    
    useEffect(() => {
        createTagsList();
    }, [selectedFilters, indexSection]);

    useEffect(() => {
        disableFilters();
    }, [tagsAll]);

    return (
        <div className="m-filter-tag-list-enc-tal">
            <div className="m-filter-tag-list-enc-tal__header">
                <p>Filtros:</p>
                <Link
                    to={`/empresas/encontrar_talento/`}
                    className="m-filter-tag-list-enc-tal__header__clean"
                    onClick={() => {
                        setSelectedFilters(initialSelectedFilters);
                        setTags([]);
                        setTagsAll([]);
                        removeChecked();
                        removeCheckedRadio();
                    }}
                >
                    <button>Limpiar</button>
                </Link>
            </div>
            <div className="m-filter-tag-list-enc-tal__mobile">
                <span onClick={handleFilters}>Filtrar por:</span>
            </div>
            <div className="m-filter-tag-list-enc-tal__body">
                <button
                    onClick={() =>
                        setIndexSection((indexSection) => indexSection - 1)
                    }
                    className={`m-filter-tag-list-enc-tal__body__btn-top ${
                        (tagsAll.length > 8 && indexSection === 1) ||
                        (tagsAll.length > 16 && indexSection === 2)
                            ? "block"
                            : ""
                    }`}
                >
                    <span className="icon-chevron-down1"></span>
                </button>
                <div className="m-filter-tag-list-enc-tal__body__inner">
                    {tags.length > 0 &&
                        tags.map((tag) => (
                            <FilterTagEncTal
                                label={tag.label}
                                name={tag.name}
                                value={tag.value}
                            />
                        ))}
                </div>
                <button
                    onClick={() =>
                        setIndexSection((indexSection) => indexSection + 1)
                    }
                    className={`m-filter-tag-list-enc-tal__body__btn-bottom ${
                        (tagsAll.length > 8 && indexSection === 0) ||
                        (tagsAll.length > 16 && indexSection === 1)
                            ? "block"
                            : ""
                    }`}
                >
                    <span className="icon-chevron-down1"></span>
                </button>
            </div>
        </div>
    );
};

export default FilterTagListEncTal;
